var exports = {
  "kL": "FormSwitch.module__container___QXFLaD",
  "oE": "FormSwitch.module__compact___QXFLaD",
  "_A": "FormSwitch.module__labelContainer___QXFLaD",
  "Pf": "FormSwitch.module__label___QXFLaD",
  "r9": "FormSwitch.module__disabled___QXFLaD",
  "vk": "FormSwitch.module__clickable___QXFLaD",
  "h_": "FormSwitch.module__description___QXFLaD",
  "HV": "FormSwitch.module__switchRoot___QXFLaD",
  "L8": "FormSwitch.module__switchThumb___QXFLaD",
  "nL": "FormSwitch.module__iconChecked___QXFLaD",
  "ao": "FormSwitch.module__iconUnchecked___QXFLaD",
};

module.exports = exports;
